
<div class="container">

    <h2>Quiénes somos</h2>
    <br>
    <strong>
        Astronomio es un proyecto que nace con el objetivo de compartir los conocimientos sobre astronomía con todo el mundo,
         sin importar cuan experimentado seas, la idea es irte con algo de informacion nueva.
    </strong>


    <p>
        Nos caracteriza la autogestión, la que consideramos como la mejor forma de llegar al público. Asumimos la responsabilidad de ser lo más claros y objetivos posible. Somos independientes, no recibimos dinero ni respondemos ante nadie más que a nosotros mismos. 
    </p>

    <div id="imagenes">
        <div class="contenedor">
            <img src="./assets/fotomia.png">
            <div class="centrado">Giuliano Tritto | Programador | Astronomo aficionado</div>
        </div>
        
    </div>
</div>
